export const ru = {
    from: 'от',
    more_details: 'Выбрать номер',
    per_night: 'за ночь',
    special_project_ya_travel: 'Специальный проект Я.Путешествий',
};
